import { useSession } from '../lib/session';
import { Brand } from './LoginPage';
import { PasswordForm } from './PasswordForm';

/** Primeiro acesso com senha temporária: a API só libera o restante após a troca. */
export function ForcedPasswordChange() {
  const session = useSession();
  return (
    <main className="flex min-h-dvh items-center justify-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-md">
        <Brand />
        <div className="mt-6 rounded-lg border border-slate-200 bg-white p-6 shadow-xs">
          <h1 className="text-lg font-semibold text-slate-900">Defina sua senha</h1>
          <p className="mt-1 mb-5 text-sm text-slate-600">
            Você entrou com uma senha temporária. Escolha uma senha pessoal para continuar.
          </p>
          <PasswordForm onChanged={session.reload} />
          <button
            type="button"
            onClick={() => void session.logout()}
            className="mt-4 text-sm text-slate-600 hover:underline"
          >
            Sair
          </button>
        </div>
      </div>
    </main>
  );
}
